<template>
    <v-card tile>
        <v-tabs
        v-model="tab"
        background-color="primary"
        dark
        center-active
        show-arrows
        >
            <v-tab>Personal</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
            <v-tab-item>
                <v-card flat>
                    <v-card-text>
                        <ValidationObserver ref="observer1">
                            <v-form ref="personalform">
                                <v-list flat>
                                    <v-list-item>
                                        <v-list-item-content>
                                            <ValidationProvider v-slot="{ errors }" name="Name" rules="required">
                                                <v-text-field
                                                v-model="form.name"
                                                :error-messages="errors"
                                                label="Name"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="Email" rules="required|email">
                                                <v-text-field
                                                v-model="form.email"
                                                :error-messages="errors"
                                                label="E-mail"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="Phone" rules="required">
                                                <v-text-field
                                                v-model="form.phone"
                                                :error-messages="errors"
                                                label="Phone"
                                                required
                                                ></v-text-field>
                                            </ValidationProvider>
                                           <ValidationProvider v-slot="{ errors }" name="Password" vid="password">
                                                <v-text-field
                                                    ref="password"
                                                    type="password"
                                                    v-model="form.password"
                                                    :error-messages="errors"
                                                    label="Password"
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="Confirm Password" rules="confirmed:password">
                                                <v-text-field
                                                    ref="password_confirmation"
                                                    type="password"
                                                    v-model="form.password_confirmation"
                                                    :error-messages="errors"
                                                    label="Confirm Password"
                                                ></v-text-field>
                                            </ValidationProvider>
                                            <ValidationProvider v-slot="{ errors }" name="4 Digit Code" rules="max:4">
                                                <v-text-field
                                                    ref="logincode"
                                                    type="logincode"
                                                    v-model="form.logincode"
                                                    :error-messages="errors"
                                                    label="Login Code"
                                                ></v-text-field>
                                            </ValidationProvider>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-form>
                        </ValidationObserver>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>                        
                        <v-btn large min-width="50%" color="blue darken-1" text to="/dashboard">Cancel</v-btn>              
                        <v-btn large min-width="50%" color="primary" tile @click="submit" :loading="loading">Update</v-btn>
                    </v-card-actions>  
                </v-card>
            </v-tab-item>
        </v-tabs-items>
    </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import { required, max } from 'vee-validate/dist/rules'
import { extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
import axios from 'axios'
import TokenService from '../services/storage.service'

setInteractionMode('eager')

extend('required', {
    ...required,
    message: '{_field_} can not be empty',
})

extend('max', {
    ...max,
    message: '{_field_} must limit to 4 digits',
})


export default {
    props: ['id'],
    data () {
        return {
            tab: null,
            form: {
                name: '',
                email: '',
                phone: '',
                password: '',
                password_confirmation: '',
                logincode: '',
                role: 'cleaner'
            },
            loading: false,
            comment: {
                comment: '',
                public: false,
                parent: null,
                type: 'comment'
            },
            token: ''
        }
    },
    created() {
        this.getCleaner()
        this.token = TokenService.getToken()
    },
    components: {
        ValidationProvider,
        ValidationObserver
    },
    methods: {
        getCleaner() {
            if(this.id) {
                axios.get('admin/users/get?id=' + this.id)
                    .then((response) => {
                        this.form = response.data
                        this.$nextTick()
                    })
            }
        },
        ...mapActions({
            updateCleaner: 'data/updateUser',
            addComment: 'data/addComment'
        }),
        async submit() {
            let valid1 = await this.$refs.observer1.validate()

            if(valid1) {
                this.loading = true
                this.$set(this.form, 'id', this.id)
                this.updateCleaner(this.form).then(() => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'green')
                    this.$store.commit('SET_SNACK', 'Successfully saved!')
                    this.form.logincode = ''
                    this.form.password = ''
                    this.form.password_confirmation = ''
                }).catch(error => {
                    this.loading = false
                    this.$store.commit('SET_SNACKTYPE', 'red')
                    if(error.response.data.error) {
                        this.$store.commit('SET_SNACK', error.response.data.error)
                    } else {
                        this.$store.commit('SET_SNACK', 'Failed to save! Please try again.')
                    }
                })
            } else {
                this.$store.commit('SET_SNACKTYPE', 'red')
                this.$store.commit('SET_SNACK', 'Please check your form for the errors.')

                if(!valid1) {
                    this.tab = 0
                }
            }
        },
    }
}
</script>

<style lang="sass" scoped>
.estimation
    background: #003e72
    color: #fff
    text-align: center
    justify-content: center
    font-size: 20px
    margin: -16px -16px 20px
header
    &.quote-bar
        position: sticky
        top: 0
        z-index: 999
.admin-action 
    background: #1976d2
    button 
        width: 95%
        background: #ffffff
        color: #1976d2
.comment-actions 
    background: #dadada
</style>
<style lang="sass">
.filepond--drop-label
    &.filepond--drop-label label
        margin: 0
        color: #fff
        font-size: 20px
        text-transform: uppercase
        font-size: 16px
        line-height: 1em

.filepond--panel-root
    background: #003a6f
    border-radius: 0
    color: #fff!important
    border: 3px dashed #ffffff

.images
    text-align: center

    img 
        max-width: 100%

.comment-text
    white-space: pre-wrap

.public
    label 
        font-size: 13px

.theme--light
    &.status
        background: #e0f2f5
</style>